import * as React from "react";
import { StatList } from "@/components/StatList";
import type { HierarchyNode } from "../types";

interface DetailViewProps<T extends HierarchyNode> {
  node: T;
  renderNodeList: (items: T[], showConnector: boolean) => React.ReactNode;
}

export function DetailView<T extends HierarchyNode>({ node, renderNodeList }: DetailViewProps<T>) {
  const items = (node.children as T[]) || [];
  const hasMetadata = node.metadata && Object.keys(node.metadata).length > 0;

  return (
    <div className="flex flex-col h-full">
      {/* Header */}
      <div className="flex-shrink-0 px-4 py-4">
        <h3 className="font-semibold text-text-primary text-lg">{node.name}</h3>
      </div>

      {/* Metadata Section */}
      {hasMetadata && (
        <div className="flex-shrink-0 border-y border-border-default px-4 py-4 bg-background-muted">
          <StatList
            items={Object.entries(node.metadata || {}).map(([key, value]) => ({
              id: key,
              label: key,
              value: value ?? "—",
            }))}
            dense
            layout="one-column"
            valueAlign="end"
            showDividers
          />
        </div>
      )}

      {/* Children List */}
      {items.length > 0 && <div className="flex-1 overflow-auto">{renderNodeList(items, false)}</div>}
    </div>
  );
}
